import store from "@/store/index"
import Notification from "@/classes/component-classes/Notification";

import axios from "axios";
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import {useDownloadLocalFile} from "@/composables/common/useDownloadLocalFile";

export default {

    async getCompanyDetail(id, route) {

        const response = await axios.get(`Company/${id}`, {

            params: {

                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async getCompanyToEdit(route, section, mode = null) {

        const response = await axios.get(`Shipment/${section}/${route.params.id}`, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                mode: mode

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data To Edit');

        });

        return response ? response.data : null;

    },


    async getShipperMetaData(route, validationSection) {

        let checkForMode = route.params.section;

        if(checkForMode === 'freightBooking' || checkForMode === 'courierBooking') checkForMode = null;

        const response = await axios.get('Shipment/metadata', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userId: store.state.userSettings.userId,
                validationPageKey: validationSection,
                mode: checkForMode
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async getPortsByCode(mode, searchTerm, isIata) {

        const response = await axios.get('Ports/search', {

            params: {

                owner: store.state.owner,
                searchTerm: searchTerm,
                mode: mode,
                isIataSearch: isIata

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async getShipperListByAccount(route) {

        const response = await axios.get('Company/account/shippers', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userId: store.state.userSettings.userId,

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async getConsigneeListByAccount(route) {

        const response = await axios.get('Company/account/consignees', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userId: store.state.userSettings.userId,

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async searchCompanyByType(route, searchValue, searchType) {

        const response = await axios.get(`Company/search/${searchType}`, {

            params: {

                searchTerm: searchValue,
                userId: store.state.userSettings.userId,
                owner:  store.state.owner,
                account: store.state.userSettings.account
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async saveAddress(tile, section, route) {

        const response = await axios.post(`Company/${tile}`, section, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userId: store.state.userSettings.userId,

            }

        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'The Data Has Not Been Saved');

        });

        return response ? response.data : null;
    },


    async getChargeableWeight(dims, weightType, route, mode = null) {
 
        const response = await axios.post('/Shipment/calculate/chargeableweight', dims, {
 
            params: {
 
                owner: store.state.owner,
                weightType: weightType,
                mode: mode
            }
 
        }).catch(function (error) {
 
            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Chargeable Weight Could Not Be Calculated');
 
        });
 
        return response ? response.data : null;
    },


    async saveBooking(model, bookingType, route, mode = null) {

        const freightBookingParams = {
            owner: store.state.owner,
            account: store.state.userSettings.account,
            userId: store.state.userSettings.userId,
            mode: mode
        }

        const courierBookingParams = {
            owner: store.state.owner,
            account: store.state.userSettings.account,
            userId: store.state.userSettings.userId,
            validationPageKey: 'courierBookingValidatedFields'
        }

        let setParams = '';

        bookingType === 'freightBooking' ? setParams = freightBookingParams : setParams = courierBookingParams

        const response = await axios.post(`Shipment/${bookingType}`, model, {

            params: setParams

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Save The Data');

        });

        return response ? response.data : null;
    },


    async getShipmentsExcelFile(searchTerm, type, hideComplete) {

        const response = await axios.get('Shipments/Search/excel', {

            responseType: 'blob',
            params: {

                accountNumber: store.state.userSettings.account,
                owner: store.state.owner,
                searchTerm: searchTerm,
                userSecurityId: store.state.userSettings.userId,
                typeFilter: type,
                hideCompleted: hideComplete
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Perform Download')

        });

        return response ? response : null;
    },

    async getCheckStockExcelFile() {

        const response = await axios.get('Stock/checkstock/excel', {

            responseType: 'blob',
            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Perform Download')

        });

        return response ? response : null;
    },


    async getShipments(route, type = 'All', hideCompleted, timeFilter = '90') {

        const response = await axios.get('Shipments/Search/', {

            params: {

                accountNumber: store.state.userSettings.account,
                owner: store.state.owner,
                userSecurityId: store.state.userSettings.userId,
                timeFilter: timeFilter,
                typeFilter: type,
                hideCompleted: hideCompleted
            }
        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },

    async getShipmentData(route) {

        const response = await axios.get(`shipment/${route.params.mode}/${route.params.id}`, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userSecurityId: store.state.userSettings.userId,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');
            store.state.hideLoadingSpinner = true;

        });

        return response ? response.data : null;
    },

    async searchShipments(searchTerm, route, type, hideComplete) {

        const response = await axios.get('Shipments/Search/omni', {

            params: {

                searchTerm: searchTerm,
                accountNumber: store.state.userSettings.account,
                owner: store.state.owner,
                userSecurityId: store.state.userSettings.userId,
                typeFilter: type,
                hideCompleted: hideComplete
            }
        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Search Data');

        });

        return response ? response.data : null;
    },

    async saveGridColumns(gridColumns) {

        const response = axios.post('User/shipments/set/columns', gridColumns).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'The Data Has Not Been Saved');

        });

        return response ? response.data : null;
    },

    async resetGridColumns(mode) {

        const response = await axios.get('User/shipments/reset/columns', {

            params: {

                securityId: store.state.userSettings.userId,
                mode: mode
            }

        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Could Not Reset The Columns');

        });

        return response ? response.data : null;
    },

    async getWarehouseStock(route) {

        const response = await axios.get('Stock/warehouses', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },


    async getWarehouseItems(route, warehouseRef) {

        const response = await axios.get('Warehouse/items', {

            params: {

                owner: store.state.owner,
                warehouseJobNumber: warehouseRef,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },


    async getLatestStock(route) {

        const response = await axios.get('Stock/checkstock', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },


    async getStockLines(route, rowId, searchCriteria) {

        const response = await axios.post('Stock/checkstock/lines', searchCriteria, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                skuId: rowId

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },

    async searchStock(searchCriteria, url) {

        const response = await axios.post(`Stock/${url}/search`, searchCriteria, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;
    },

    async getStockMetaData(validationSection) {

        const response = await axios.get('Stock/metadata', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userId: store.state.userSettings.userId,
                validationPageKey: validationSection,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getStockDescriptions(route, stockCode) {

        const response = await axios.get('Stock/descriptions', {

            params: {

                stockCode: stockCode,
                account: store.state.userSettings.account,
                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getUserInfoById(userId) {

        const response =  axios.get('User/' + userId, {}).catch(function(error) {

            console.log(`Method: getUserInfoById. User Id: ${userId} Error: ${error}`);

            let appInsights = new ApplicationInsights({ config: {
                    connectionString: 'InstrumentationKey=5ad06641-dc1a-427e-af43-df60fabd94de;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/',
                    /* ...Other Configuration Options... */
                    //loggingLevelConsole: 2,

                } });

            appInsights.loadAppInsights(false);

            appInsights.trackException({exception: new Error(error  )});

            let errorPage = document.getElementById('error')
            errorPage.style.cssText += "visibility: visible"

        });

        return response;
    },

    async saveShowShipmentsTabConfiguration(saveObject) {

        const response =  axios.post('User/shipments/set/tabs', saveObject).catch(function(error) {

            store.state.banners.error = new Notification(true, 'Could Not Save Tab Configuration');

        });

        return response;
    },


    async getSkuHistoryGroupedNames() {

        const response = await axios.get('Stock/skuhistory', {

            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getSkuHistoryGroupedSkuInfo(skuComp) {

        const response = await axios.get('Stock/skuhistory/skucomposite/history', {

            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
                skuComposite:skuComp
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async searchSkuHistory(searchCriteria) {

        const response = await axios.post('Stock/skuhistory/search', searchCriteria, {

            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async skuHistoryExcelDownload(searchCriteria) {

        const response = await axios.get('Stock/skuhistory/excel', {

            responseType: 'blob',
            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
                skuNumber: searchCriteria.skuNumber,
                skuGroup: searchCriteria.skuGroup,
                skuName: searchCriteria.skuName,
                jobNumber: searchCriteria.jobNumber,
                dateFrom: searchCriteria.dateFrom,
                dateTo: searchCriteria.dateTo,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Perform Download')

        });

        return response ? response : null;
    },

    async sortShipmentsGridColumn(columnData) {

        const response =  axios.post('GridSort/sort', columnData, {

            params: {

                gridKey: columnData.gridKey,

            }


        } ).catch(function(error) {

            store.state.banners.error = new Notification(true, 'Could Not Sort The Column Data');

        });

        return response;
    },

    async getPickstockShipments() {

        const response = await axios.get('Stock/pickstock/shipments', {

            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },


    async searchPickstockShipments(criteria) {

        const response = await axios.post('Stock/pickstock/shipments/search', criteria, {

            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getWarehouseDocumentsList(warehouseRef) {

        const response = await axios.get('Warehouse/documents', {

            params: {

                owner: store.state.owner,
                warehouseRef: warehouseRef,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Any Documents');

        });

        return response ? response.data : null;
    },

    async browsePicksExcelDownload(searchCriteria, isSearch) {

        const response = await axios.post('Stock/pickstock/shipments/excel', searchCriteria,  {

            responseType: 'blob',
            params: {

                account: store.state.userSettings.account,
                owner: store.state.owner,
                searchable: isSearch

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Perform Download')

        });

        return response ? response : null;
    },


    async savePickstockDetails(details) {

        const response = await axios.post('Stock/pickstock/save', details, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                securityId: store.state.userSettings.userId,
                userName: `${store.state.userSettings.firstName} ${store.state.userSettings.lastName}`,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Save The Data');

        });

        return response ? response.data : null;

    },

    async getStockOverPickDetail() {

        const response = await axios.get('Stock/pickstock/checkoverpick',{

            params: {

                owner: store.state.owner,

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Get Stock Over Pick Setting');

        });

        return response ? response.data : null;

    },

    async unPickStock(pickLine) {

        const response = await axios.post('Stock/pickstock/unpick', pickLine, {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                securityId: store.state.userSettings.userId,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Unpick Selected Stock');

        });

        return response ? response.data : null;

    },

    async getWarehousePickStockDetail(warehouseJobNumber) {

        const response = await axios.get('Warehouse/pickstock/detail', {

            params: {

                owner: store.state.owner,
                warehouseJobNumber: warehouseJobNumber,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Any Documents');

        });

        return response ? response.data : null;
    },

    async getCompanyDetailByAddress(addressLines) {

        const response = await axios.post(`Company/address`, addressLines ,{

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getShipmentConsolJobs(jobId) {

        const response = await axios.get('Shipments/Consoljobs', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                id: jobId,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Any Job Data');

        });

        return response ? response.data : null;
    },

    async getDocuments(dataRange, searchCriteria) {

        const response = await axios.post('documents/search', searchCriteria ,{

            params: {

                owner: store.state.owner,
                dataRange: dataRange,
                account: store.state.userSettings.account,
                accountType: "Customer"

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async getSelectedDocuments(selected) {

        const response = await axios.post('documents/viewdocs', selected ,{

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                accountType: "Customer"

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Data');

        });

        return response ? response.data : null;

    },

    async saveQuote(quoteData) {

        const response = await axios.post('quote/save', quoteData ,{

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userName: `${store.state.userSettings.firstName} ${store.state.userSettings.lastName}`,
                userId: store.state.userSettings.userId
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'An Error Occured Saving The Quote');

        });

        return response ? response.data : null;

    },

    async updateQuote(quoteData) {

        const response = await axios.post('quote/update', quoteData ,{

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                userName: `${store.state.userSettings.firstName} ${store.state.userSettings.lastName}`,
                userId: store.state.userSettings.userId
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'An Error Occured Saving The Quote');

        });

        return response ? response.data : null;

    },

    async getPortCountry(unLocode) {

        const response = await axios.get('quote/port/country', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
                unLocode: unLocode,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Any Job Data');

        });

        return response ? response.data : null;

    },

    async getDocumentForDownload(doc) {

        const response = await axios.get('shipments/document',{

            responseType:'blob',

            params: {
                owner: store.state.owner,
                id: doc.id
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Download Document');

        });

        return response ? response.data : null;


    },

    async getListOfReports() {

        const response = await axios.get('reports/availablereports',{

            params: {
                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve List Of Reports');

        });

        return response ? response.data : null;


    },
    async getContainerMacroPointLink(selectedId) {

        const response = await axios.get('macropoint/order/tracking',{

            params: {

                owner: store.state.owner,
                orderId: selectedId,

            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve The MacroPoint Link');

        });

        return response ? response.data : null;

    },


    async getReport(row) {

        const response = await axios.post('reports/report', row,{

            params: {
                owner: store.state.owner,
                account: store.state.userSettings.account,
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve List Of Reports');

        });

        return response ? response.data : null;

    },

    async getReportExcelFile(gridDetail, queryName) {

        const response = await axios.post('reports/report/excel', gridDetail, {

            responseType: 'blob',

            params: {
                owner: store.state.owner,
                account: store.state.userSettings.account,
                reportName: queryName
            }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Generate Excel File');

        });

        return response ? response : null;

    },

    async updateJobDocuments(bookingType, files, jobId, jobNumber, custRef) {

        const response = await axios.post('documents/update/docs', files,{

            params: {

                securityId: store.state.userSettings.userId,
                bookingType: bookingType,
                jobNumber: jobNumber,
                jobId: jobId,
                customerRef: custRef,
              }

        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Update Documents');

        });

        return response ? response : null;

    },

    async getBrowseQuoteDetail() {

        const response = await axios.get('quote/browse', {

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,
            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Quote Detail');

        });

        return response ? response.data : null;
    },

    async searchBrowseQuoteDetail(quoteSearchCriteria) {

        const response = await axios.post('quote/browse/search', quoteSearchCriteria,{

            params: {

                owner: store.state.owner,
                account: store.state.userSettings.account,

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Quote Detail');

        });

        return response ? response.data : null;
    },

    async getQuoteDetail(quoteReference){

        const response = await axios.get('quote/view',{

            params: {

                owner: store.state.owner,
                quoteReference : quoteReference

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Quote Detail');

        });

        return response ? response.data : null;
    },

    async getQuoteCharges(quoteNumber){

        const response = await axios.get('quote/charges',{

            params: {

                owner: store.state.owner,
                quoteNumber : quoteNumber

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Retrieve Quote Charges');

        });

        return response ? response.data : null;
    },

    async updateQuoteDocuments(quoteNumber, files){

        const response = await axios.post('quote/update/docs', files ,{

            params: {

                securityId: store.state.userSettings.userId,
                quoteNumber : quoteNumber,
                userName: `${store.state.userSettings.firstName} ${store.state.userSettings.lastName}`,

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Update Documents');

        });

        return response ? response.data : null;
    },

    async getQuoteDocuments(quoteNumber){

        const response = await axios.get('quote/documents',{

            params: {

                quoteNumber: quoteNumber,
                owner: store.state.owner,

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, `Could Not Retrieve Documents for:- ${quoteNumber}`);

        });

        return response ? response.data : null;
    },

    async downloadDocument(id) {

        let serverErrorMessage = null;
        let response = null;

        try {
            response = await axios.get('Shipments/document', {
                responseType: 'blob',
                params: {
                    owner: store.state.owner,
                    id: id
                }
            });


        } catch (error) {

            store.state.banners.warning = new Notification(true, `Could Not Download Document,
                             View the error info next to the download icon`);

            if (error.response && error.response.data) {
                // Convert blob to text and parse JSON
                const msg = await error.response.data.text();
                const parsed = JSON.parse(msg);
                serverErrorMessage = parsed;
            }

        }

        return serverErrorMessage || response;
    },

    async acceptQuoteNotification(model, quoteNumber) {

        const response = await axios.post('quote/accept/notify', model ,{

            params: {

                securityId: store.state.userSettings.userId,
                userName: `${store.state.userSettings.firstName} ${store.state.userSettings.lastName}`,
                owner: store.state.owner,
                account: store.state.userSettings.account,

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Send Accept Notification');

        });

        return response ? response.data : null;
    },

    async getQuoteValidators() {

        const response = await axios.get('quote/validators', {

            params: {

                userId: store.state.userSettings.userId,

            }
        }).catch(function (error) {

            store.state.banners.error = new Notification(true, 'Could Not Send Accept Notification');

        });

        return response ? response.data : null;
    },

    async getConsolJobData(id, type, hideComplete) {

        const response = await axios.get('Shipments/Consoljob', {

            params: {

                id: id,
                accountNumber: store.state.userSettings.account,
                owner: store.state.owner,
                userSecurityId: store.state.userSettings.userId,
                typeFilter: type,
                hideCompleted: hideComplete
            }
        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Could Not Retrieve The Search Data');

        });

        return response ? response.data : null;
    },


    async FileVirusScan(file){

        const formData = new FormData();
        formData.append('file', file);
        
        const response = await axios.post('Shipment/filescan', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).catch(function (error) {
            store.state.banners.error = new Notification(true, 'File May Contain A Virus');
            return null;
        });

        return response ? response.data : null;
    },

    async generateQrLablel(jobDetail) {

        const response = await axios.get('Shipments/labels', {

            responseType: 'blob',

            params: {

                id: jobDetail.id,
                account: jobDetail.account,
                owner: jobDetail.owner,
                jobNumber: jobDetail.jobNumber,
                docType: jobDetail.docType,
                labelType: jobDetail.labelType,
            }
        }).catch(function (error) {

            store.state.hideLoadingSpinner = true;
            store.state.banners.error = new Notification(true, 'Could Not Get Label Data');

        });

        return response ? response.data : null;
    },

    async saveUserLogin(userSecurityId){

        const response = await axios.post('User/userlogin/log', userSecurityId, {

            params: {

                securityId: userSecurityId,
            }

        }).catch(function (error) {

            // store.state.banners.warning = new Notification(true, 'Failed To Log User');

        });

        return response ? response.data : null;
    },


}
